import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { Turbo } from "@hotwired/turbo-rails"

// Drag-and-drop reordering of mission task result cards on the mission show
// page's Results tab (card #3635). Persists the new order via PATCH to
// MissionTasksController#reorder. Modelled on
// runbook_node_sortable_controller.js (the cleanest minimal Sortable +
// Stimulus pairing in the codebase) -- this controller's own element IS the
// sortable list (the grid div), unlike the runbook one which sorts a nested
// `list` target inside a wrapping element, so no separate target is needed
// here.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this._sortable = Sortable.create(this.element, {
      handle: "[data-sort-handle]",
      animation: 150,
      ghostClass: "opacity-40",
      chosenClass: "sortable-chosen-ring",
      forceFallback: true,
      fallbackOnBody: false,
      swapThreshold: 0.65,
      onEnd: () => this._persistOrder()
    })
  }

  disconnect() {
    this._sortable?.destroy()
    this._sortable = null
  }

  async _persistOrder() {
    const cards = this.element.querySelectorAll("[data-mission-task-id]")
    const ids = Array.from(cards).map(el => el.dataset.missionTaskId).filter(Boolean)
    if (ids.length === 0 || !this.hasUrlValue) return

    // Optional chaining, matching config_preview_controller.js's convention --
    // the meta tag is absent whenever forgery protection is disabled (e.g.
    // the test environment), not just in production.
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify({ ids })
    })

    if (!response.ok) return

    const html = await response.text()
    Turbo.renderStreamMessage(html)
  }
}
